// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DriverSchedules_header__ThQ7o {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  border-bottom: 1px solid #cfcfcf;
  padding-bottom: 15px;
}

.DriverSchedules_title__0-bkR {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.DriverSchedules_submit__yq0YU {
  width: 250px;
  font-weight: 700;
  font-size: 13px;
}

.DriverSchedules_timePicker__RIDxT{
  width: 200px;
}

.DriverSchedules_labelFormItem__KLRuR {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/pages/driver-detail/styles/DriverSchedules.module.css"],"names":[],"mappings":"AACA;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAIA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":["\n.header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 15px;\n    border-bottom: 1px solid #cfcfcf;\n    padding-bottom: 15px;\n  }\n  \n  .title {\n    color: var(--darkGray);\n    font-family: BebasNeue;\n    font-weight: 700;\n    font-size: 20px;\n  }\n  \n  \n  \n  .submit {\n    width: 250px;\n    font-weight: 700;\n    font-size: 13px;\n  }\n  \n  .timePicker{\n    width: 200px;\n  }\n  .labelFormItem {\n    font-weight: 500;\n    color: var(--darkGray);\n    font-size: 12px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `DriverSchedules_header__ThQ7o`,
	"title": `DriverSchedules_title__0-bkR`,
	"submit": `DriverSchedules_submit__yq0YU`,
	"timePicker": `DriverSchedules_timePicker__RIDxT`,
	"labelFormItem": `DriverSchedules_labelFormItem__KLRuR`
};
export default ___CSS_LOADER_EXPORT___;
